import useFlags from "@common/hooks/useFlags";

// release.configurable-governance gates minimum-hours and rate-rules. It
// defaults ON: LaunchDarkly returns undefined for a flag it has not been
// told about yet, so only an explicit false hides the fields.
export const useConfigurableGovernance = (): boolean =>
  useFlags().releaseConfigurableGovernance !== false;
